import React from 'react';
import logger from '@/logger';
import { ImageUpload as CommonImageUpload } from '@blueprintnyc/bpnyc-common-admin';
import { imgCustomReq } from 'utils';

const ImageUpload = props => {
	const { endpoint } = props;

	if (!endpoint) {
		logger.error(new Error('ImageUpload: missing required prop `endpoint` (signed URL endpoint)'), {
			location: 'ImageUpload',
		});
		return null;
	}

	const onUploadSuccess = imgCustomReq(endpoint);

	return <CommonImageUpload {...props} onUploadSuccess={onUploadSuccess} />;
};

export default ImageUpload;
